"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _mobxReact = require("mobx-react");
var _mapValues = _interopRequireDefault(require("lodash/mapValues"));
var _pick = _interopRequireDefault(require("lodash/pick"));
var _enums = require("../../enums");
var _Field = _interopRequireDefault(require("../Field"));
var _constants = require("../../constants");
var _styles = require("./styles");
var _FormattedComponents = require("../FormattedComponents");
var _ForgotWorkspacePasswordDialog = _interopRequireDefault(require("../ForgotWorkspacePasswordDialog"));
var _posthogUtils = require("../../utils/posthog-utils");
var _posthogEvents = require("../../posthog-events");
var _messages = _interopRequireDefault(require("./messages"));
var _loginErrors = _interopRequireDefault(require("../../login-errors"));
var _dec, _class;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var EmailAndPasswordLogin = (_dec = (0, _mobxReact.inject)('store'), _dec(_class = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_Component) {
  function EmailAndPasswordLogin() {
    var _this;
    _classCallCheck(this, EmailAndPasswordLogin);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, EmailAndPasswordLogin, [].concat(args));
    _defineProperty(_this, "onForgotPasswordClick", function () {
      var _router$params;
      var store = _this.props.store;
      var forgotWorkspacePasswordDialog = store.forgotWorkspacePasswordDialog,
        app = store.app,
        router = store.router;
      var openDialog = forgotWorkspacePasswordDialog.openDialog;
      var views = app.views;
      var isEmailLogin = ((_router$params = router.params) === null || _router$params === void 0 || (_router$params = _router$params.loginType) === null || _router$params === void 0 ? void 0 : _router$params.toUpperCase()) === _enums.DOMAIN_LOGIN_OPTIONS.EMAIL;
      if (isEmailLogin) {
        (0, _posthogUtils.posthogCapture)(_posthogEvents.posthogEvents.selectForgotPassword);
        router.goTo(views.requestResetPassword, {});
      } else {
        openDialog();
      }
    });
    _defineProperty(_this, "onAllSignInOptionsClick", function () {
      var _router$queryParams;
      var store = _this.props.store;
      var app = store.app,
        router = store.router,
        authLogin = store.authLogin;
      var setShowErrorMessage = authLogin.setShowErrorMessage;
      var views = app.views;
      router.goTo(views.domainLogin, {}, {
        redirect: (_router$queryParams = router.queryParams) === null || _router$queryParams === void 0 ? void 0 : _router$queryParams.redirect
      });
      setShowErrorMessage(false);
    });
    return _this;
  }
  _inherits(EmailAndPasswordLogin, _Component);
  return _createClass(EmailAndPasswordLogin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
        formatMessage = _this$props.intl.formatMessage,
        auth = _this$props.store.auth;
      var translations = (0, _mapValues["default"])((0, _pick["default"])(_messages["default"], ['cantSignInToWorkspace']), function (message) {
        return formatMessage(message);
      });
      auth.setTranslations(translations);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var authLogin = this.props.store.authLogin;
      var setErrorResponse = authLogin.setErrorResponse;
      setErrorResponse(null);
    }
  }, {
    key: "render",
    value: function render() {
      var _router$params2;
      var _this$props2 = this.props,
        formatMessage = _this$props2.intl.formatMessage,
        isMobile = _this$props2.isMobile,
        store = _this$props2.store,
        loginOption = _this$props2.loginOption;
      var _store$auth = store.auth,
        domainLoginForm = _store$auth.domainLoginForm,
        submitDomainLoginForm = _store$auth.submitDomainLoginForm,
        domainLoginFormEmailPassword = _store$auth.domainLoginFormEmailPassword,
        submitDomainLoginFormEmailPassword = _store$auth.submitDomainLoginFormEmailPassword,
        isOnlyOneLoginOption = _store$auth.isOnlyOneLoginOption,
        _store$authLogin = store.authLogin,
        isInputFocused = _store$authLogin.isInputFocused,
        setIsInputFocused = _store$authLogin.setIsInputFocused,
        errorResponse = _store$authLogin.errorResponse,
        setErrorResponse = _store$authLogin.setErrorResponse,
        showErrorMessage = _store$authLogin.showErrorMessage,
        views = store.app.views,
        router = store.router;
      if (errorResponse && errorResponse.data === _loginErrors["default"].LOGIN_OPTION_NOT_ALLOWED && errorResponse.status === 403) {
        store.router.goTo(views.domainLogin, {});
      }
      var isEmailLogin = loginOption ? loginOption === _enums.DOMAIN_LOGIN_OPTIONS.EMAIL : ((_router$params2 = router.params) === null || _router$params2 === void 0 || (_router$params2 = _router$params2.loginType) === null || _router$params2 === void 0 ? void 0 : _router$params2.toUpperCase()) === _enums.DOMAIN_LOGIN_OPTIONS.EMAIL;
      var form = isEmailLogin ? domainLoginFormEmailPassword : domainLoginForm;
      var _form$values = form.values(),
        email = _form$values.email,
        password = _form$values.password;
      var isValidEmail = email ? _constants.emailValidationRegex.test(email) : true;
      if (!isValidEmail) {
        setErrorResponse(null);
      }
      var isValidEmailForm = password && email;
      var isDisabled = isEmailLogin ? !isValidEmailForm : !password;
      var _onSubmit = isEmailLogin ? submitDomainLoginFormEmailPassword : submitDomainLoginForm;
      var posthogEvent = isEmailLogin ? _posthogEvents.posthogEvents.attemptEmailSignIn : _posthogEvents.posthogEvents.attemptWorkspacePasswordSignIn;
      var inputStyles = {
        Input: (0, _styles.getHeight)()
      };
      var passwordPlaceholderLocalizedEntry = isEmailLogin ? _messages["default"].formField_domainPassword : _messages["default"].formField_workspacePassword;
      return /*#__PURE__*/_react["default"].createElement(_styles.LoginForm, {
        onSubmit: function onSubmit(e) {
          e.preventDefault();
          (0, _posthogUtils.posthogCapture)(posthogEvent);
          if (isValidEmail) {
            _onSubmit();
          }
        }
      }, isEmailLogin && /*#__PURE__*/_react["default"].createElement(_styles.EmailWrapperDiv, null, /*#__PURE__*/_react["default"].createElement(_Field["default"], {
        placeholder: formatMessage(_messages["default"].email),
        id: "email",
        hideError: true,
        styles: inputStyles,
        onChange: function onChange(e) {
          return form.$('email').sync(e.target.value);
        },
        onFocus: function onFocus() {
          return setIsInputFocused(true);
        },
        onBlur: function onBlur() {
          return setIsInputFocused(false);
        }
      })), !isValidEmail && !isInputFocused && !errorResponse && showErrorMessage && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, formatMessage(_messages["default"].invalidEmail))), /*#__PURE__*/_react["default"].createElement(_Field["default"], {
        placeholder: formatMessage(passwordPlaceholderLocalizedEntry),
        field: "password",
        id: "password",
        type: "password",
        hideError: true,
        styles: inputStyles,
        form: form,
        onChange: function onChange(e) {
          return form.$('password').sync(e.target.value);
        },
        withPasswordToggle: true
      }), !isMobile && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
        alignText: 'right'
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        onClick: this.onForgotPasswordClick
      }, formatMessage(isEmailLogin ? _messages["default"].forgotYourPassword : _messages["default"].forgotWorkspacePassword))), this.renderError() && /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorWrapper, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledErrorIcon, {
        name: 'warning'
      }), /*#__PURE__*/_react["default"].createElement(_styles.ErrorNotification, null, this.renderError())), /*#__PURE__*/_react["default"].createElement(_styles.StyledButton, {
        isMobile: isMobile,
        type: "submit",
        disabled: isDisabled
      }, formatMessage(_messages["default"].signIn)), isMobile && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, {
        isMobile: true,
        alignText: 'right'
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        onClick: this.onForgotPasswordClick
      }, formatMessage(_messages["default"].forgotYourPassword))), !isMobile && !isOnlyOneLoginOption && /*#__PURE__*/_react["default"].createElement(_styles.StyledText, null, /*#__PURE__*/_react["default"].createElement(_styles.StyledButtonLink, {
        onClick: this.onAllSignInOptionsClick
      }, /*#__PURE__*/_react["default"].createElement(_styles.StyledIcon, {
        name: 'arrow-left'
      }), formatMessage(_messages["default"].allSignInOptions))), /*#__PURE__*/_react["default"].createElement(_ForgotWorkspacePasswordDialog["default"], {
        isMobile: isMobile
      }));
    }
  }, {
    key: "renderError",
    value: function renderError() {
      var _router$params3;
      var store = this.props.store;
      var authLogin = store.authLogin,
        auth = store.auth,
        router = store.router,
        app = store.app;
      var views = app.views;
      var errorResponse = authLogin.errorResponse;
      var setHasLoginError = auth.setHasLoginError;
      var resetPasswordLink = window.location.origin + views.requestResetPassword.path;
      var isEmailLogin = ((_router$params3 = router.params) === null || _router$params3 === void 0 || (_router$params3 = _router$params3.loginType) === null || _router$params3 === void 0 ? void 0 : _router$params3.toUpperCase()) === _enums.DOMAIN_LOGIN_OPTIONS.EMAIL;
      if (!errorResponse) {
        return null;
      }
      var status = errorResponse.status,
        data = errorResponse.data;
      var renderedErrorConfig = [{
        shouldRender: status === 401 && data === 'invalid_password' && isEmailLogin || status === 403 && data === 'user_disabled' && isEmailLogin,
        message: _messages["default"].wrongEmailOrPassword
      }, {
        shouldRender: status === 500 && data === 'invalid_password' && !isEmailLogin,
        message: _messages["default"].wrongWorkspacePassword
      },
      //Not able to login with email 4 times
      {
        shouldRender: status === 401 && data === _loginErrors["default"].FIFTH_ATTEMPT && isEmailLogin,
        message: _messages["default"].wrongEmailOrPasswordFourTimes,
        values: {
          helpArticle: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
            href: _constants.helpArticleURL,
            target: "_blank"
          }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].helpArticle))
        }
      },
      //Not able to login with email 10 times
      {
        shouldRender: status === 429 && data === _loginErrors["default"].TOO_MANY_REQUESTS && isEmailLogin,
        message: _messages["default"].wrongEmailOrPasswordTenTimes,
        values: {
          passwordResetLink: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
            href: resetPasswordLink,
            target: "_blank"
          }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].passwordResetLink))
        }
      },
      //Not able to login because the current change password was wrong 10 times
      {
        shouldRender: status === 429 && data === _loginErrors["default"].TOO_MANY_CHANGE_REQUESTS && isEmailLogin,
        message: _messages["default"].wrongCurrent10thTime,
        values: {
          passwordResetLink: /*#__PURE__*/_react["default"].createElement(_styles.StyledLink, {
            href: resetPasswordLink,
            target: "_blank"
          }, /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _messages["default"].passwordResetLink))
        }
      },
      //If the user has more than 10 failed loggin attempts with workspace password
      {
        shouldRender: status === 401 && data === _loginErrors["default"].TENTH_ATTEMPT && !isEmailLogin,
        message: _messages["default"].tooManyFailedAttempts
      },
      //If the user has more than 31 failed loggin attempts with workspace password
      {
        shouldRender: status === 429 && !isEmailLogin,
        message: _messages["default"].tooManyFailedAttemptsBlocked
      },
      //Does not have right to access the workspace while logging in with email and password
      {
        shouldRender: status === 403 && data === _loginErrors["default"].NOT_ALLOWED_WORKSPACE && isEmailLogin,
        message: _messages["default"].doesNotHaveAccess
      }];
      var renderedError = renderedErrorConfig.find(function (element) {
        return element.shouldRender;
      });
      if (renderedError) {
        setHasLoginError(true);
        return /*#__PURE__*/_react["default"].createElement(_FormattedComponents.FormattedMessage, _extends({}, renderedError.message, {
          values: renderedError.values
        }));
      } else {
        setHasLoginError(false);
      }
    }
  }]);
}(_react.Component)) || _class) || _class);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(EmailAndPasswordLogin);
//# sourceMappingURL=index.js.map